import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { InactivityLogoutService } from './shared/inactivity-logout.service';
import { CommonService } from './shared/common.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
    <app-inactivity-warning-modal></app-inactivity-warning-modal>
  `,
})
export class AppComponent implements OnInit, OnDestroy {
  private routerSubscription?: Subscription;

  constructor(
    private router: Router,
    private inactivityService: InactivityLogoutService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    // Initialize inactivity tracking if user is logged in
    if (this.commonService.isLoggedIn()) {
      this.inactivityService.resumeTracking();
    }

    // Monitor route changes to resume/stop tracking
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.onNavigationEnd());
  }

  private onNavigationEnd(): void {
    if (this.commonService.isLoggedIn()) {
      this.inactivityService.resumeTracking();
    } else {
      this.inactivityService.stopTracking();
    }
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
